var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaTxtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_txt_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139342",
    "data-name": "\\uD328\\uC2A4 139342",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139343",
    "data-name": "\\uD328\\uC2A4 139343",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139344",
    "data-name": "\\uD328\\uC2A4 139344",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.922.922,0,0,1,.269.269.9.9,0,0,1,.91,0H27.076a.91.91,0,0,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.805 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139345",
    "data-name": "\\uD328\\uC2A4 139345",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139346",
    "data-name": "\\uD328\\uC2A4 139346",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139347",
    "data-name": "\\uD328\\uC2A4 139347",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139348",
    "data-name": "\\uD328\\uC2A4 139348",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#377de2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139355",
    "data-name": "\\uD328\\uC2A4 139355",
    d: "M12.037,4.1H2.048a2.049,2.049,0,0,1,0-4.1h9.989a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 31.329)",
    fill: "#5e9cf7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139356",
    "data-name": "\\uD328\\uC2A4 139356",
    d: "M19.432,4.1H2.048a2.048,2.048,0,1,1,0-4.1H19.432a2.048,2.048,0,1,1,0,4.1Z",
    transform: "translate(16.491 44.164)",
    fill: "#2266d3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139357",
    "data-name": "\\uD328\\uC2A4 139357",
    d: "M12.037,4.1H2.048a2.049,2.049,0,0,1,0-4.1h9.989a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 56.999)",
    fill: "#5e9cf7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139358",
    "data-name": "\\uD328\\uC2A4 139358",
    d: "M19.432,4.1H2.048a2.049,2.049,0,0,1,0-4.1H19.432a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(16.491 69.834)",
    fill: "#2266d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139359",
    "data-name": "\\uD328\\uC2A4 139359",
    d: "M12.038,4.1H2.049a2.049,2.049,0,1,1,0-4.1h9.989a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(44.029 31.329)",
    fill: "#5e9cf7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139360",
    "data-name": "\\uD328\\uC2A4 139360",
    d: "M19.432,4.1H2.049a2.048,2.048,0,1,1,0-4.1H19.432a2.048,2.048,0,1,1,0,4.1Z",
    transform: "translate(44.029 44.164)",
    fill: "#2266d3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139361",
    "data-name": "\\uD328\\uC2A4 139361",
    d: "M12.038,4.1H2.049a2.049,2.049,0,1,1,0-4.1h9.989a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(44.029 56.999)",
    fill: "#5e9cf7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139362",
    "data-name": "\\uD328\\uC2A4 139362",
    d: "M19.432,4.1H2.049a2.049,2.049,0,1,1,0-4.1H19.432a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(44.029 69.834)",
    fill: "#2266d3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139371",
    "data-name": "\\uD328\\uC2A4 139371",
    d: "M9.1,1.723H5.685v8.661H3.411V1.723H0V0H9.1Zm10.415,8.661h-2.7l-2.4-3.7-2.453,3.7H9.478l3.666-5.216L9.554,0h2.694l2.343,3.562L16.989,0h2.488L15.859,5.078Zm9.478-8.661H25.578v8.661H23.3V1.723H19.893V0h9.1Z",
    transform: "translate(7.555 9.191)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaTxtIcon);
export default __webpack_public_path__ + "static/media/minerva_txt_icon.6f1791ca26314c003bae14d4662f3c85.svg";
export { ForwardRef as ReactComponent };